<template>
  <div class="blank-page container1 d-flex flex-column h-100">
    <Navigation/>
    <!--		  mx-auto container -->
    <div class="app-content content flex-shrink-0 ">
      <div class="content-wrapper">
        <div class="content-body" v-if="authenticated">
          <router-view></router-view>
        </div>
      </div>

    </div>
    <Footer/>
  </div>
</template>

<script>
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import {mapGetters} from 'vuex'

export default {
  name: 'Home',
  components: {
    Navigation,
    Footer
  },
  computed: {
    ...mapGetters({
      authenticated: 'auth/authenticated',
    })
  },
  // watch: {
  //     '$route'(to) {
  //
  //     }
  // },
}
</script>

<style>
.app-content {
  padding-top: 5rem;
}
</style>